// @ts-nocheck
// Supabase client — single instance, used everywhere in the app.
//
// Configuration is read from CRA env vars (must be REACT_APP_* prefixed
// so CRA exposes them to the browser bundle). The values themselves are
// safe to ship in client code: data access is gated by Row-Level
// Security policies on the database side, not by hiding the key.
//
// Local dev: .env.local (gitignored)
// Production: set the same vars in Vercel project settings → Environment Variables
//
// `@ts-nocheck` matches the project's existing convention (see App.tsx).
// TS 4.4.4 can't parse @supabase/supabase-js's `exports` field; webpack
// resolves the module fine at runtime. Proper fix lands when we modernise
// the toolchain (TS upgrade or Vite migration).

import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Loud failure during dev. In production, the build would have already
  // baked the values in; missing vars at runtime means a misconfigured deploy.
  // eslint-disable-next-line no-console
  console.error(
    "Supabase env vars missing. Expected REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY."
  );
}

export const supabase = createClient(url ?? "", anonKey ?? "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true, // for magic-link callbacks
  },
});
